import { useEffect, useContext } from "react"
import { useFormikContext } from "formik"
import { UserContext } from "../../../context/userContext"
import { FormContext } from "../../../context/formContext"

import styles from "../../../styles/Form.module.css"

export default function ParticipantId({ field, index }) {
  const formik = useFormikContext()
  const user = useContext(UserContext)
  const form = useContext(FormContext)

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    const currentParticipantId = user.participant_id
    if (!currentParticipantId) {
      formik.setFieldValue(field.field_name, "not-set")
    }
    formik.setFieldValue(field.field_name, currentParticipantId)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={styles.hidden} style={{ order: index }}>
      <input
        type="hidden"
        name={field.field_name}
        value={formik.values[field.field_name]}
      />
    </div>
  )
}
